<script>
	import { enhance } from '$app/forms';
	import { goto } from '$app/navigation';
	import { page } from '$app/stores';
	import { Button, PasswordInput, Logo, TextInput } from '@resider/design-system';
	import { t } from '@resider/i18n';

	$: password = '';
</script>

<form
	class="sign-up-form"
	action="?/email_signup&next={encodeURIComponent(
		$page.url.searchParams.get('next') || `/${$page.params.lang}/${$t('slugs.account')}`
	)}"
	method="POST"
	use:enhance={() => {
		return async ({ result }) => {
			if (result.type === 'redirect') {
				console.log('redirect after sign up to:', result.location);

				goto(result.location, { invalidateAll: true });
			}
		};
	}}
>
	<TextInput name="email" placeholder={$t('global.Provide your e-mail address')} type="email" />

	<PasswordInput
		placeholder={$t('global.Enter a secure password')}
		showPasswordMeter
		name="password"
		bind:value={password}
	/>

	<Button type="submit">
		{$t('global.Create a free account')}
	</Button>

	<Button
		href="/{$page.params.lang}/{$t('slugs.sign-in')}{$page.url.searchParams.has('next')
			? `?next=${$page.url.searchParams.get('next')}`
			: ''}"
		kind="tertiary"
	>
		{$t(`global.I want to sign in`)}
	</Button>
</form>

<style>
	form {
		display: grid;
		gap: 1rem;
		max-width: 20rem;
		margin: 0 auto 1rem;
	}
</style>
